import type { ReactNode } from 'react';

type NavBarContainerV2Props = {
  children: ReactNode;
};

const NavBarContainerV2 = ({ children }: NavBarContainerV2Props) => {
  return (
    <div className="flex flex-col h-full w-full min-w-full lg:bg-color-white relative overflow-hidden">{children}</div>
  );
};

export default NavBarContainerV2;
